import { render, staticRenderFns } from "./PKCChecklistDetailsTab.vue?vue&type=template&id=82c145e8&scoped=true"
import script from "./PKCChecklistDetailsTab.vue?vue&type=script&lang=js"
export * from "./PKCChecklistDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c145e8",
  null
  
)

export default component.exports